<script setup lang="ts">
import { getConfig } from '~/config/constants';

const constants = getConfig(useRuntimeConfig());
const { vResponsive } = useResizeObserverGlobal();
const { user, isImpersonating } = useMmaBaseUser();
</script>
<template>
  <a
    href="#main"
    class="sr-only transition-all focus:not-sr-only focus:absolute z-[200] top-1 left-1 !p-2 shadow-lg bg-white dark:bg-gray-900"
  >
    Skip to content
  </a>
  <div id="container" v-responsive>
    <div
      :class="[
        'flex bg-white dark:bg-gray-900',
        { 'pt-7': isImpersonating },
      ]"
    >
      <HeaderImpersonationBanner v-if="isImpersonating" :user="user" />
      <div id="sidebar" class="hidden lg:flex lg:flex-col min-h-screen max-w-2xs w-full">
        <slot name="sidebar" />
      </div>
      <div id="main-column" class="flex-1 min-w-0 flex flex-col ">
        <div class="pb-20 sm:pb-0">
          <header
            id="header"
            :class="[
              'border-b bg-white p-4 w-full flex justify-between items-center',
              'fixed z-20 sm:static sm:z-0 min-h-12',
            ]"
          >
            <slot name="header" />
          </header>
        </div>
        <div class="flex-1 max-w-6xl mx-auto w-full">
          <div class="xl:flex flex-1 gap-8 py-5 px-5 h-full flex-col md:flex-row">
            <div id="main" class="flex-1 mb-5 md:mb-0 w-full">
              <slot name="content" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="bg-(--color-primary-800) max-w-2xs w-full hidden lg:block" />
      <UiGradguardFooter
        :urls="{
          gradguard: constants.domains.gradguard,
          members: constants.domains.members,
        }"
        class="flex-1"
      />
    </div>
  </div>
</template>
